import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyHeader.css';

const PolicyHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="policy-header">
      <img
        src="/footer/rklogo.png"
        alt="Robokalam"
        className="policy-logo"
        onClick={() => navigate('/')}
      />
    </div>
  );
};

export default PolicyHeader;
